module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_f_erythristic.832ea2c0.png";